const productHeaderGetters = {
  productHeaderProps(state, getters) {
    return {
      badges: getters.computedBadges,
      brand: state.product.brand,
      isPreorder: getters.isPreorder,
      reviewSummary: getters.computedReviewSummary,
      showProductBadge: getters.showProductBadge,
      title: state.product.title
    };
  },
  /**
   * getters.computedBadges
   *
   * @param {Array} state.product.badges: list of badges applicable to the product,
   *   in priority order
   * @param {Boolean} getters.outletBadgeIndex: index of the OutletBadge if it exists,
   *   else return -1
   * @returns {Array} Product badge objects
   */
  computedBadges(state, getters) {
    let returnBadges = [];
    const badges = getters.staffPicksFilteredBadges;
    const {
      outletBadgeIndex
    } = getters;
    const hasOutletBadge = outletBadgeIndex !== -1;
    if (badges.length > 1 && hasOutletBadge) {
      const badgesWithoutOutlet = badges.filter((badge, index) => index !== outletBadgeIndex);
      returnBadges = [badgesWithoutOutlet[0], badges[outletBadgeIndex]];
    } else if (badges.length) {
      returnBadges = [badges[0]];
    }
    return returnBadges;
  },
  staffPicksFilteredBadges(state, getters) {
    return state.product.badges.filter((badge) => {
      let shouldInclude = true;
      if (getters.hideStaffPickBadge && badge.badgeText === "Staff Pick") shouldInclude = false;
      return shouldInclude;
    });
  },
  /**
   * getters.outletBadgeIndex
   *
   * @param {Array} state.product.badges: list of badges applicable to the product,
   *   in priority order
   * @returns {Number}: index of the OutletBadge if it exists, else return -1
   */
  outletBadgeIndex(state, getters) {
    return getters.staffPicksFilteredBadges.findIndex((badge) => (badge == null ? void 0 : badge.badgeText) === "REI Outlet");
  },
  /**
   * showProductBadge
   * @params from getters:
   *  @param {Object} computedBadges: data for populating the badge
   * @returns {Boolean}: whether or not badge should be shown.
   */
  showProductBadge(state, getters) {
    return getters.computedBadges.length > 0;
  },
  /**
   * getters.computedReviewSummary
   * TODO: Controller ticket PDM-3068 - return default structure for review data
   *
   * @param {Object} reviewSummary Object containing summary of reviews data
   * @return {Object} review summary object from state or default rating
   */
  computedReviewSummary(state) {
    const defaultReviewSummary = {
      averageRating: 0,
      count: 0
    };
    if (state.product.reviewSummary) {
      const {
        averageRating,
        count
      } = state.product.reviewSummary;
      return averageRating && count ? state.product.reviewSummary : defaultReviewSummary;
    }
    return defaultReviewSummary;
  }
};
export {
  productHeaderGetters as default
};
//# sourceMappingURL=productHeaderGetters.mjs.map
